import React from 'react'

function HospitalUserLoginLogs() {
  return (
    <div>User Login Logs</div>
  )
}

export default HospitalUserLoginLogs